module.exports = __webpack_public_path__ + "img/3B3B3B_C7C7C7_878787_A4A4A4-256px.65570911.png";